export enum DrawerName {
	projectManualRunSettings = "projectManualRunSettings",
	events = "events",
	chatbot = "chatbot",
}
